window.onload = (e) => {
  pnav();
  initMenuToggle();
  introSlider();
  caseSlider();
  memberSlider();
  faqAccordion();
  // SendContact();
  popupFunc();
  problemModal();
  showBnr();
  check();
  voiceAccordion();
  let width = window.innerWidth;
  if (width < 768) {
    flowSlider();
  }
};

function voiceAccordion() {
  const heads = document.querySelectorAll(".voice-head");

  heads.forEach((head) => {
    head.addEventListener("click", () => {
      const content = head.nextElementSibling;

      // アコーディオン形式なので他を閉じる
      document.querySelectorAll(".voice-content").forEach((c) => {
        if (c !== content) {
          c.style.maxHeight = null;
          c.style.padding = null;
        }
      });

      document.querySelectorAll(".voice-head").forEach((h) => {
        if (h !== head) {
          h.classList.remove("is-open");
        }
      });

      // 自分自身をトグル
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        content.style.padding = null;
        head.classList.remove("is-open");
      } else {
        content.style.padding = "30px 20px 0";
        content.style.maxHeight = content.scrollHeight + 30 + "px";
        head.classList.add("is-open");
      }
    });
  });
}

function problemModal() {
  const popup = document.getElementById("popup02");
  const allPopupImages = popup.querySelectorAll(".popup-img");

  document.querySelectorAll(".intro-list__type01 li").forEach((li) => {
    li.addEventListener("click", function () {
      const id = li.id; // 例: popup02-item01

      // すべての画像を一旦非表示に
      allPopupImages.forEach((img) => {
        img.style.display = "none";
      });

      // 対応する画像だけ表示
      const targetImg = popup.querySelector("." + id);
      if (targetImg) {
        targetImg.style.display = "block";
      }

      // ポップアップ表示
      popup.classList.add("is-show");
    });
  });
  // モーダル内の a タグをクリックしたら is-show を外す
  popup.querySelectorAll("a").forEach((a) => {
    a.addEventListener("click", function () {
      popup.classList.remove("is-show");
    });
  });
  // ポップアップの「閉じる」ボタン
  document
    .querySelector(".popup02_close")
    .addEventListener("click", function () {
      document.querySelector(".popup02").classList.remove("is-show");
    });
}

function popupFunc() {
  setTimeout(() => {
    document.querySelector(".popup").classList.add("is-show");
  }, 120000); // 2分後に実行

  // ポップアップの「閉じる」ボタン
  document.querySelector(".popup_close").addEventListener("click", function () {
    document.querySelector(".popup").classList.remove("is-show");
  });
}

function check() {
  $(".check-map > span").on("click", function () {
    // すべての .check-map > span の active クラスをリセット
    $(".check-map > span").removeClass("is-active");
    // クリックされた要素に is-active クラスを追加
    $(this).addClass("is-active");

    // クリックされた .check-map > span のクラスを取得
    let clickedClassList = $(this).attr("class").split(" ");

    // 特定のクラス（is-active以外）を取得
    let targetClass = clickedClassList.find((cls) => cls !== "is-active");

    // .check-content_text を非表示
    $(".check-content_text").css("display", "none");
    // .check-content_result を表示
    $(".check-content_result").css("display", "block");

    // .check-content_result にクリックされた要素のクラスを追加
    if (targetClass) {
      $(".check-content_result")
        .removeClass()
        .addClass("check-content_result " + targetClass);
      $(".check-map")
        .removeClass()
        .addClass("check-map " + targetClass);
    }
  });
}

window.addEventListener("resize", function () {
  let width = window.innerWidth;
  if (width < 768) {
    flowSlider();
  }
});

function initMenuToggle() {
  document.addEventListener("click", (e) => {
    const hamburger = document.querySelector(".hamburger");
    if (!hamburger) return;
    const isFiredInToggle = hamburger.contains(e.target);
    const isMenuOpened = document.querySelector(".hamburger.is-open") !== null;
    if (!isFiredInToggle || isMenuOpened) return;

    hamburger.classList.add("is-open");
    const globalNav = document.querySelector(".sp-nav");
    globalNav.classList.add("is-open");
    const hideMenu = (e) => {
      globalNav.classList.remove("is-open");
      hamburger.classList.remove("is-open");
      document.removeEventListener("click", hideMenu);
    };
    document.addEventListener("click", hideMenu);
  });
}

function pnav() {
  var windowWidth = $(window).width();
  var headerHight = $("header").outerHeight();
  var urlHash = location.hash; // ハッシュ値があればページ内スクロール
  if (urlHash) {
    // 外部リンクからのクリック時
    $("body,html").stop().scrollTop(0); // スクロールを0に戻す
    setTimeout(function () {
      // ロード時の処理を待ち、時間差でスクロール実行
      var target = $(urlHash);
      var position = target.offset().top - headerHight;
      $("body,html").stop().animate(
        {
          scrollTop: position,
        },
        500
      ); // スクロール速度ミリ秒
    }, 100);
  }
  $('a[href^="#"]').on("click", function () {
    console.log(headerHight);
    var speed = 1000;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top - headerHight;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    const hamburger = document.querySelector(".hamburger");
    const globalNav = document.querySelector(".sp-nav");
    globalNav.classList.remove("is-open");
    hamburger.classList.remove("is-open");
    return false;
  });
}

function introSlider() {
  const options = {
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000, // スライドが流れる速度を設定
    cssEase: "linear", // スライドの流れ方を等速に設定
    infinite: true,
    slidesToShow: 3.5,
    arrows: false,
    dots: false,
    centerMode: true,
    centerPadding: "10%",
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
      {
        breakpoint: 1064,
        settings: {
          slidesToShow: 1.5,
          centerPadding: "6%",
        },
      },
    ],
  };
  $(".intro-slider").slick(options);
}

function caseSlider() {
  const options = {
    infinite: true,
    slidesToShow: 3,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    prevArrow: '<div class="slide-arrow prev-arrow"></div>',
    nextArrow: '<div class="slide-arrow next-arrow"></div>',
    responsive: [
      {
        breakpoint: 1064,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "6%",
        },
      },
    ],
  };
  $(".case-slider").slick(options);
}

function memberSlider() {
  const options = {
    infinite: true,
    slidesToShow: 3,
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    prevArrow: '<div class="slide-arrow prev-arrow"></div>',
    nextArrow: '<div class="slide-arrow next-arrow"></div>',
    responsive: [
      {
        breakpoint: 1064,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "5%",
        },
      },
    ],
  };
  $(".member-slider").slick(options);
}

function flowSlider() {
  const options = {
    infinite: false,
    initialSlide: 0,
    slidesToScroll: 1,
    slidesPerView: 1,
    arrows: true,
    variableWidth: true,
    dots: true,
    prevArrow: '<div class="slide-arrow prev-arrow"></div>',
    nextArrow: '<div class="slide-arrow next-arrow"></div>',
  };
  $(".flow-list").slick(options);
}

function faqAccordion() {
  $(".faq-list__item dt").on("click", function () {
    $(this).parents(".faq-list__item").toggleClass("is-open");
    $(this).next(".faq-list__item dd").slideToggle();
  });
}

function showBnr() {
  var tellBnr = document.querySelector(".fixed-tell");
  window.addEventListener("scroll", function () {
    // window.pageYOffset 現在の位置を取得
    if (window.pageYOffset > 100) {
      tellBnr.classList.add("is-show");
    } else {
      tellBnr.classList.remove("is-show");
    }
  });
}

// function SendContact() {
//   const thanksElement = $(".contact-thanks");
//   const formElement = $(".contact-main");
//   const bnrElement = $(".contact-bnr");
//   const leadElement = $(".contact-lead");
//   // 送信完了時にモーダルを表示する(*3)
//   document.addEventListener("wpcf7mailsent", function (e) {
//     thanksElement.css("display", "block");
//     formElement.css("display", "none");
//     bnrElement.css("display", "none");
//     leadElement.css("display", "none");
//   });
// }
